import { CustomSelect } from "#/components/atoms";
import type { DaAnswerStatusFilter } from "#/components/exam-results/context/descriptive/types";
import { useDaContext } from "../../context/descriptive/context";
import styles from "./styles.module.scss";

type Props = {
  moduleGroupFilters: { label: string; value: string }[];
};

const filterItems: { label: string; value: DaAnswerStatusFilter }[] = [
  { label: "درست", value: "corrects" },
  { label: "غلط", value: "incorrects" },
  { label: "نزده", value: "no-answers" },
  { label: "همه سوالات", value: "all" }
];

const DesktopDescriptiveAnswerReportFilter = (props: Props) => {
  const { setFilters, setPage, filters } = useDaContext();
  const { moduleGroupFilters } = props;

  return (
    <div className={styles["filter-desktop-container__items"]}>
      <div>فیلتر: </div>
      <div>
        <CustomSelect
          options={moduleGroupFilters}
          placeholder="گروه درسی"
          selectedOption={
            moduleGroupFilters.find(
              (item) => Number(item.value) == filters.selectedModuleGroup
            ) ?? null
          }
          onChange={(option) => {
            if (option) {
              setFilters({
                ...filters,
                selectedModuleGroup: Number(option.value)
              });
              setPage(1);
              return option;
            }
          }}
          tabIndex={0}
          disabled={false}
          containerClassName={
            styles["filter-desktop-container__items__filters-dropdown"]
          }
          bodyClassName={
            styles["filter-desktop-container__items__filters-dropdown__body"]
          }
        />
      </div>
      <div>
        <CustomSelect
          options={filterItems}
          placeholder="وضعیت پاسخ"
          selectedOption={
            filterItems.find(
              (item) => item.value == filters.selectedAnswerStatus
            ) ?? null
          }
          onChange={(option) => {
            if (option) {
              setFilters({
                ...filters,
                selectedAnswerStatus: option.value as DaAnswerStatusFilter
              });
              setPage(1);
              return option;
            }
          }}
          tabIndex={0}
          disabled={false}
          containerClassName={
            styles["filter-desktop-container__items__filters-dropdown"]
          }
          bodyClassName={
            styles["filter-desktop-container__items__filters-dropdown__body"]
          }
        />
      </div>
    </div>
  );
};

export default DesktopDescriptiveAnswerReportFilter;
